// extracted by mini-css-extract-plugin
export default {"subtitleWrapper":"subtitleWrapper--FmUqy","subtitle":"subtitle--bQ8SQ"};